import React from 'react';
import CardButton from '../CardButton/CardButton';
import './HomeSlide.css';
import ProgressMeter from '../ProgressMeter/ProgressMeterTutor';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_overview} from '../../../../../cosmosTracking/cosmosEvents';
import Lottie from "react-lottie";
import holippl from '../../../../../assets/images/holi-people.png'
import { resolveTutorHomeAsset } from '../tutorHomeConfig';
function HomeSlide(props) {
	const { data, campaignOrg, rewardText, goalPrefix = 'Goal:', config = {} } = props;
	const text = config.text || {};
	const images = config.images || {};
	return (
		<div className="slideCard slideCardHome">
			<div className="cardBody" style={images.card_background ? {'--tutor-home-card-background': `url("${resolveTutorHomeAsset(images.card_background)}")`} : undefined}>
				{/* <img src={holippl} className='overlay-image' /> */}
				<div className="body-card-inner">
				  <img src={resolveTutorHomeAsset(images.header_artwork || 'https://cdn-wl-assets.classplus.co/production/379965/ff1969ee-f1cd-4b80-a468-2c6bc89980d4.jpeg')} alt="signature"/>
				</div>
			
				
				{/* <img className="home-top-img" src={holititle2} alt="signature"/> */}
				<hr className="img-border" />
				<div className="revenueData">
					<img
						src={resolveTutorHomeAsset(images.revenue_divider)}
						alt="border" height={50} width={4}/>
					<div>
						<h4>{data?.revenueCard?.text}</h4>
						<div className="revenue-total-row">
							<h1>{data?.revenueCard?.total}</h1>
							<p className="revenue-goal">{goalPrefix} {data?.revenueCard?.goal}</p>
						</div>
					</div>
				</div>
				<div className="meterData">
					<ProgressMeter width={data?.revenueCard?.percentage}/>
				</div>
				<div className="pointDataGroup">
					<div className="pointData">
						<img src={resolveTutorHomeAsset(images.rank_icon || 'https://cdn-cp-assets-public.classplus.co/campaigns-assets/rep-25-slide-1-medal-star-ind-26.png')} width={24} alt="star"/>
					<div className="rank-title-group-left">
					<h3>{data?.rankCard?.title}</h3>  <span className="rank-subtext">{text.rank_label || 'Your Rank'}</span>
					</div>
					</div>
					<div className="pointData">
					<img
					src={resolveTutorHomeAsset(images.points_icon || 'https://cdn-cp-assets-public.classplus.co/campaigns-assets/diwali-point-white-icon-ind-26.png')}
					alt="circle-point" width={22} height={22}/> 
					<div className="rank-title-group-left">
					<h3>{data?.pointsCard?.title} </h3> <span className="rank-subtext">{text.points_label || 'Your Points'}</span>
					</div>
					</div>
				</div>
				<CardButton text={text.cta_label || 'Start the campaign'}
							deeplink={data?.deeplinkOverview}
							className={'btn-action'}
							eventCallback={() => {
								cosmosTrackService(view_overview)
							}}>
				</CardButton>
			</div>
		</div>
	);
}

export default HomeSlide;
